import type { Section } from "../sections";
import { Screen } from "./Screen";

/**
 * A section that exists in the nav and not yet on the screen.
 *
 * **It says so plainly, and points at what does work today.** #300's placeholder made the same
 * call for the whole app, for the same reason: a page that implied the panel worked would be
 * worse than no page at all, and a family who came here to correct something needs to know
 * where they *can* do it — which for now is the conversation, in Claude or ChatGPT.
 *
 * It names no date, and nothing here is a promise: the issue behind each section is in the
 * code (`sections.ts`), not in the copy.
 *
 * It uses the same {@link Screen} band the real screens will, so replacing one is a body swap
 * rather than a re-layout — and so a family meets one page shape rather than two.
 */
export function Placeholder({ section }: { section: Section }) {
  return (
    <Screen title={section.label} blurb={section.blurb}>
      <div className="notice">
        <p className="notice__body">
          This part of the panel isn't built yet. For now, ask <strong>@boone</strong> in Claude or
          ChatGPT — everything here is something you can already say out loud.
        </p>
      </div>
    </Screen>
  );
}
